import React from 'react';

function Footer() {
  return (
    <footer className="container-fluid d-flex align-items-center header footer justify-content-center " style={{ backgroundColor: "#6a5acd", color: "#fff", padding: "10px 20px" }}>
      <p>&copy; 2024 CO-BUDDY,All rights reserved.</p>
    </footer>
  );
}

export default Footer;